import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[cepMask]'
})
export class CepDirective {
  onTouched: any;
  onChange: any;
  value: '';
  cepType: string = '99999-999';

  @Input('cepMask') cepMask: string;

  constructor() { }

  @HostListener('keyup', ['$event'])
  onKeyup($event: any) {

    const value = this.lessMask($event.target.value);

    if ($event.keyCode === 8) {
      return value;
    }

    if (value.length <= 7) {
      $event.target.value = this.mascaraCep(value);
    } else if (value.length === 8) {
      $event.target.value = this.mascaraCep(value);
      return $event.target.value;
    } else {
      return $event.target.value;
    }

  }

  @HostListener('blur', ['$event'])
  onBlur($event: any) {
    let cep = this.lessMask($event.target.value);
    if (cep.length === this.cepType.length - 2) {
      return $event.target.value = this.mascaraCep(cep);
    }
    if ($event.target.value.length === this.cepType.length) {
      return $event.target.value;
    } else {
      return $event.target.value;
    }

  }

  mascaraCep(value: string): string {
    value = this.lessMask(value);
    const replacement = this.cepType.replace(/\D/g, '').replace(/9/g, '_');
    const valueMask = value + replacement.substring(0, replacement.length - value.length);
    let valueMaskPos = 0;

    value = '';
    for (let i = 0; i < this.cepType.length; i++) {
      if (isNaN(parseInt(this.cepType.charAt(i)))) {
        value += this.cepType.charAt(i);
      } else {
        value += valueMask[valueMaskPos++];
      }
    }

    if (value.indexOf('_') > -1) {
      value = value.substr(0, value.indexOf('_'));
    }

    return value;

  }

  lessMask(cep) {
    return  cep.replace(/\D/g, '');
  }
  @HostListener('dragover', ['$event'])
  drag(event: DragEvent) {
    event.preventDefault();
  }
}
